import React, { useEffect, useState } from 'react';
import { Table, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { getStockHistoryAll } from '../../../actions/report';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

const { Title } = Typography;

const StockHistoryAllPage = () => {
  const [summaryData, setSummaryData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      const result = await dispatch(getStockHistoryAll());
      if (result) {
        setSummaryData(result);
      }
    };

    fetchData();
  }, [dispatch]);

  const columns = [
    { title: 'Product Title', dataIndex: 'title', key: 'title' },
    { title: 'Total Product Entries', dataIndex: 'total_entries', key: 'total_entries' },
    { title: 'Stocks + Floating + Sold', dataIndex: 'calculated_total', key: 'calculated_total' },
    {
      title: 'Balance Status',
      dataIndex: 'is_balanced',
      key: 'is_balanced',
      render: (is_balanced) =>
        is_balanced ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        ) : (
          <CloseCircleTwoTone twoToneColor="#ff4d4f" />
        ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>All Products Stock Summary</Title>
      <Table
        dataSource={summaryData}
        columns={columns}
        rowKey="title"
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default StockHistoryAllPage;
